













import { PhoenixLocale } from '@front-app/modules/i18n/model/locale';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import SelectBox from './SelectBox.vue';

const LANGUAGE_OPTIONS: PhoenixLocale[] = [
	PhoenixLocale.DEVICE_DEFAULT,
	PhoenixLocale.EN,
	PhoenixLocale.FR,
];

// Each language choice should display in the actual language to make it easier for
// users to switch
const LANGUAGE_LABELS = {
	[PhoenixLocale.EN]: 'English',
	[PhoenixLocale.FR]: 'Français',
};

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: String as PropType<PhoenixLocale>,
			required: true,
		},
	},
	setup(props, ctx) {
		const getLabelForKey = (key: PhoenixLocale): string => {
			if (key === PhoenixLocale.DEVICE_DEFAULT) {
				return ctx.root.$t('interface-language-device-default') as string;
			}
			return LANGUAGE_LABELS[key];
		};

		const selectOptions = computed(() => LANGUAGE_OPTIONS.map((key) => ({
			key,
			label: getLabelForKey(key),
		})));
		return {
			getLabelForKey,
			selectOptions,
		};
	},
});
